import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=14da2cb4"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14da2cb4')) {
      api.createRecord('14da2cb4', component.options)
    } else {
      api.reload('14da2cb4', component.options)
    }
    module.hot.accept("./Brand.vue?vue&type=template&id=14da2cb4", function () {
      api.rerender('14da2cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Brand.vue"
export default component.exports